var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "link_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40.8 40.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".link_svg__st0{fill:#5200f1;stroke:#5200f1}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link_svg__Website",
    transform: "translate(.497 .499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "link_svg__Path_180",
    className: "link_svg__st0",
    d: "M35.1 4.6a8.39 8.39 0 00-11.9 0l-5.9 5.9c-.5.5-.5 1.3 0 1.8s1.3.5 1.8 0L25 6.4c2.3-2.3 5.9-2.3 8.2 0s2.3 5.9 0 8.2l-7.8 7.8c-2.3 2.3-5.9 2.3-8.2 0-.5-.5-1.3-.5-1.8 0s-.5 1.3 0 1.8c3.3 3.3 8.6 3.3 11.9 0l7.8-7.8c3.3-3.2 3.3-8.5 0-11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "link_svg__Path_181",
    className: "link_svg__st0",
    d: "M19.6 28.4l-5 5c-2.3 2.2-6 2.2-8.2-.1-2.2-2.3-2.2-5.8 0-8.1l7.3-7.3c2.3-2.3 5.9-2.3 8.2 0 .5.5 1.3.5 1.8 0s.5-1.3 0-1.8a8.39 8.39 0 00-11.9 0l-7.3 7.3c-3.2 3.3-3.1 8.6.2 11.8 3.3 3.2 8.5 3.2 11.7 0l5-5c.5-.5.5-1.3 0-1.8s-1.3-.5-1.8 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6869c01aafd612e37a493ccc41e2c56e.svg";
export { ForwardRef as ReactComponent };